/* eslint-disable no-unused-vars */

import store from '@/store';

// eslint-disable-next-line no-unused-vars
const DDMMYYYY = ({ date }) => {
  return new Date(date).toLocaleDateString('es-CL');
};

const config = {
  useStreetCabinetUploadField: true,

  requestMapShowActiveRedMarker: false,

  visibleRequestsByRealisationStatuses: {
    completed: false,
    cancelled: true,
    onhold: true
  },

  assetManagement: {
    columns: []
  },
  // Enable the possibility to reset or cancel already saved date
  canResetDateValue: true,

  finUnit: [
    'Qwello-Infra-B.V.',
    'spv-evnet-nl',
    'friesland-bv',
    'spv-b1',
    'spv001',
    'spv002',
    'spv003',
    'spv004',
    'spv005',
    'spv006',
    'spv007',
    'spv008',
    'spv009'
  ],

  preparationDateFields: {},


};
export default config;
